<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.push({path: '/', query: {device: $route.query.device, hospital: $route.query.hospital}})">返回</div>
      <span class="inline fr">订单列表</span>
    </div>
    <div class="content-box-sco">
      <div class="form-box">
        <select v-model="value">
          <option v-for="(item, index) in options" name="sendSymbolId" :value="item.value" :key="index">{{item.label}}</option>
        </select>
        <!-- <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </div>
      <template v-if="list && list.length > 0">
        <div class="form-box goods" v-for="(item, index) in list" :key='index'>
          <div class="txt-top">
            <div class="inline left">{{item.type === 0 ? '待付款' : (item.type === 1 ? '已取消' : (item.type === 2 ? '已付款' : (item.type === 3 ? '已开票' : '')))}}</div>
            <div class="inline right">单号：{{item.order_id}}</div>
          </div>
          <div class="txt-content">
            <div class="inline img">
              <img src="../assets/logo.png" alt=""/>
            </div>
            <div class="inline con">
              <p>{{item.service.name}}</p>
              <p>订单时间：{{item.created_time | formatDate}}</p>
              <p>金额：{{item.price}}</p>
              <p>{{item.invoice_type === 0 ? '不开发票' : (item.invoice_type === 1 ? '电子发票' : '')}}</p>
              <p v-if="item.invoice_type !== 0">发票抬头：{{item.invoice_title}}</p>
              <p v-if="item.invoice_type === 2">纳税人识别号：{{item && item.invoice_ident ? item.invoice_ident : ''}}</p>
              <p v-if="item.invoice_type === 2">纳税人地址：{{item && item.invoice_addr ? item.invoice_addr : ''}}</p>
              <p v-if="item.invoice_type === 2">纳税人电话：{{item && item.invoice_phone ? item.invoice_phone : ''}}</p>
              <p v-if="item.invoice_type === 2">开户银行：{{item && item.invoice_bank ? item.invoice_bank : ''}}</p>
              <p v-if="item.invoice_type === 2">银行账户：{{item && item.invoice_bank_account ? item.invoice_bank_account : ''}}</p>
              <p v-if="item.invoice_type !== 0">邮箱：{{item && item.invoice_mail ? item.invoice_mail : ''}}</p>
              <p v-if="item.invoice_type === 2">备注：{{item && item.comment ? item.comment : ''}}</p>
              <p v-if="item.invoice_type === 2">收票人手机：{{item && item.invoice_recv_phone ? item.invoice_recv_phone : ''}}</p>
              <p>{{item.type === 0 ? '待付款' : (item.type === 2 ? '已付款' : (item.type === 3 ? '已开票' : (item.type === 1 ? '已取消' : '')))}}</p>
            </div>
          </div>
          <div class="txt-bottom tr">
            <el-button v-if="item.type === 0" size="mini" @click="cancel(item)">取消</el-button>
            <el-button v-if="item.type === 0" size="mini" @click="$router.push(({path: '/pay', query: {device: $route.query.device, orderId: item.order_id, hospital: $route.query.hospital}}))">详情</el-button>
            <el-button v-if="item.type === 0" type="primary" size="mini" @click="$router.push(({path: '/pay', query: {device: $route.query.device, hospital: $route.query.hospital, orderId: item.order_id}}))">去支付</el-button>
            <el-button size="mini" v-if='item.type === 2' @click="$router.push(({path: '/modify', query: {device: $route.query.device, hospital: $route.query.hospital, orderId: item.order_id}}))">修改发票详情</el-button>
          </div>
        </div>
      </template>
      <div class="tc" v-else>暂无订单</div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/index'
import { getOrder, cancelOrder } from '@/api'
export default {
  data () {
    return {
      options: [
        {
          value: '-1',
          label: '全部订单'
        },
        {
          value: '0',
          label: '待付款'
        },
        {
          value: '2',
          label: '已付款'
        },
        {
          value: '3',
          label: '已开票'
        },
        {
          value: '1',
          label: '已取消'
        }
      ],
      value: '-1',
      list: []
    }
  },
  methods: {
    cancel (data) {
      cancelOrder(data.order_id).then(res => {
        this.init()
      })
    },
    init () {
      var formData = new FormData()
      formData.append('type', this.value !== '-1' ? this.value : '')
      formData.append('token', this.$cookies.get('h5_token'))
      getOrder(formData).then(res => {
        this.list = res
      }).catch(() => {
        this.$cookies.remove('h5_user')
        this.$cookies.remove('h5_token')
        this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
      })
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    value (val) {
      this.init()
    }
  },
  filters: {
    formatDate (value) {
      return formatDate(value, 'YYYY-MM-DD hh:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select{
  width: 100%;
  margin-bottom: 4%;
}
.form-box.goods{
  padding: 2% 0;
  border-top: 1px solid #539edf;
  .txt-top{
    line-height: 40px;
    .left{
      font-size: 14px;
      color: #66b1ff;
      margin-right: 20px;
    }
  }
  .txt-content{
    white-space: nowrap;
    .img{
      width: 20%;
      height: 20%;
      text-align: center;
      line-height: 100px;
      // border: 1px solid #333;
      margin-right: 10px;
      vertical-align: top;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .con{
      width: 68%;
      line-height: 25px;
      p{
        width: 100%;
        white-space: pre-wrap;
      }
    }
  }
  .txt-bottom{
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/goods.vue